import { PersistentError } from './PersistentError';
export class EntityExistsError extends PersistentError {
    /**
     * @param entity - The entity which cause the error
     */
    constructor(entity) {
        super(`The entity ${entity} is managed by a different db.`);
        this.entity = entity;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRW50aXR5RXhpc3RzRXJyb3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJFbnRpdHlFeGlzdHNFcnJvci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsZUFBZSxFQUFFLE1BQU0sbUJBQW1CLENBQUM7QUFHcEQsTUFBTSxPQUFPLGlCQUFrQixTQUFRLGVBQWU7SUFNcEQ7O09BRUc7SUFDSCxZQUFZLE1BQWM7UUFDeEIsS0FBSyxDQUFDLGNBQWMsTUFBTSxnQ0FBZ0MsQ0FBQyxDQUFDO1FBQzVELElBQUksQ0FBQyxNQUFNLEdBQUcsTUFBTSxDQUFDO0lBQ3ZCLENBQUM7Q0FDRiJ9